module.exports = __webpack_public_path__ + "img/pr-2.859d5875.png";